import { Table } from 'react-bootstrap'
import { dayName } from 'utils'

export function TableReportSchedules({ report }) {
    return (
        <Table>
            <thead>
                <tr>
                    <th>Día</th>
                    <th>Horario</th>
                    <th className='text-center'>Modalidad</th>
                </tr>
            </thead>
            <tbody>
                {report.map((value) => {
                    return (
                        <tr key={value.id}>
                            <td>{dayName(value.dia)}</td>
                            <td>{`${value.hora_inicio.substring(0, 5)} - ${value.hora_fin.substring(0, 5)}`}</td>
                            <td className='text-center'>{value.habilitado ? 'Virtual' : 'Presencial'}</td>
                        </tr>
                    )
                })}
            </tbody>
        </Table>
    )
}
